import React from 'react';
import { Button, Image, Box } from '@chakra-ui/react';
import Logo from 'images/logo.svg';

const Footer = () => {
  const footerItems = [
    {
      path: '/pricing',
      text: 'Pricing',
    },
    {
      path: '/sitemap',
      text: 'Sitemap',
    },
    {
      path: '/about',
      text: 'About Us',
    },
    {
      path: '/contact',
      text: 'Contact Us',
    },
    {
      path: '/privacy',
      text: 'Privacy Policy',
    },
    {
      path: '/refund',
      text: 'Refund Policy',
    },
    {
      path: '/terms',
      text: 'Terms and Conditions',
    },
  ];

  const footerLinks = () => {
    return (
      <Box my='40px' fontSize='12px'>
        {footerItems.map((item, index) => (
          <Box
            key={index}
            as='a'
            _focus={{ textDecoration: 'none' }}
            mx='10px'
            target='blank'
            href={item.path}
            my='10px'
          >
            {item.text}
          </Box>
        ))}
      </Box>
    );
  };
  return (
    <Box
      textAlign='center'
      maxWidth='780px'
      margin='0 auto'
      color='white'
      mt='160px'
      pb='260px'
      px={['32px', '32px', '32px', '0px']}
    >
      <Box mb='160px'>
        <Box justifyContent='center' display='flex' alignItems='center'>
          <Image src={Logo} alt='logo' boxSize='50px' />
        </Box>
        <Box my='40px' fontSize='28px' mx='auto'>
          Your clients deserve a <br />
          premium photo viewing experience
        </Box>
        <a href='/login'>
          <Button
            bg='#fff'
            borderRadius='24px'
            width='200px'
            height='48px'
            fontSize='14px'
            fontWeight='bold'
            fontFamily='bold'
            wordSpacing='2px'
            color='dark.100'
          >
            Login or Register
          </Button>
        </a>
      </Box>
      {footerLinks()}
      <Box mt='16px' fontSize='12px'>
        Albumshot is your one stop platform to create professional client
        galleries without any coding knowledge.
      </Box>
    </Box>
  );
};
export default Footer;
